module.exports = __webpack_public_path__ + "static/img/pass_by_skt.d3525a74.svg";